import cronstrue from 'cronstrue'

interface CronParseResult {
    description: string | null
    error: string | null
}

export function parseCronExpression(expression: string, options?: {use24HourTimeFormat?: boolean; locale?: string}): CronParseResult {
    const trimmed = expression.trim()
    if (!trimmed) return {description: null, error: null}

    try {
        return {description: cronstrue.toString(trimmed, options), error: null}
    } catch (err) {
        return {description: null, error: err instanceof Error ? err.message : String(err)}
    }
}
